import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import commonSlice from './sliceCreators/commonSlice';
import materialsSlice from './sliceCreators/materialsSlice';
import projectsSlice from './sliceCreators/projectsSlice';
import recommendSlice from './sliceCreators/recommendSlice';

const store = configureStore({
  reducer: {
    projects: projectsSlice,
    common: commonSlice,
    materials: materialsSlice,
    recommend: recommendSlice,
  },
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export type AppThunk = ThunkAction<void, RootState, unknown, Action>;

export default store;
